import Head from 'next/head';
import { Header, Footer, Plain } from '@components';
import { Box, Flex } from '@chakra-ui/react';

export function PolicyPage() {
  return (
    <Flex direction={'column'} minH={'100vh'}>
      <Head>
        <title>
          Polityka prywatności | IKSEL Studio Reklamy - Reklama dla Twojej firmy
        </title>

        <meta
          name="description"
          content="IKSEL Studio Reklamy - Polityka prywatności i szczegóły dotyczące jak przetwarzamy Twoje dane. Kompleksowa obsługa reklamowa i kampanie marketingowe"
        />
      </Head>

      <Header
        id="header"
        logo={{
          imageUrl: '/images/logo_medium.png',
          href: '/',
        }}
        menu={{
          elements: [
            {
              id: 'header-strona-glowna-link',
              label: 'Strona główna',
              href: '/',
            },
            {
              id: 'header-oferta-link',
              label: 'Oferta',
              href: '/#oferta',
            },
            {
              id: 'header-aktualnosci-link',
              label: 'Aktualności',
              href: 'https://www.facebook.com/IKSEL.reklama',
            },
            {
              id: 'header-kontakt-link',
              label: 'Kontakt',
              href: '/kontakt',
            },
          ],
        }}
      />

      <Box flex={1}>
        <Plain
          id="polityka-prywatnosci"
          title="Polityka prywatności"
          subtitle="Przywiązujemy dużą uwagę do ochrony Twoich danych osobowych"
          html={`
            <h3>Zasady działania serwisu:</h3>
            <ul>
              <li>Wszystkie uzyskane dane wykorzystujemy tylko i wyłącznie na potrzeby serwisu www.iksel.com.pl w celu realizacji zam&oacute;wienia oraz informowaniu o wszelkich zmianach bądź promocjach.</li>
              <li>Nie prowadzimy kontroli ani weryfikacji danych podanych przez użytkownik&oacute;w w formularzach.</li>
              <li>Wysoki stopień zabezpieczenia danych osobowych jest skutkiem dbałości o administracyjne oraz techniczne metody przetrzymywania danych i ochrona ich przez nieautoryzowanym ujawnieniem, wykorzystanie, zmianą lub zniszczeniem.</li>
              <li>Strona korzysta z tak zwanych "ciasteczek". Są one wykorzystywane jedynie do prowadzenia statystyk odwiedzin na stronie. Przebywając na stronie zgadza się na zapisywanie ciasteczek w Twojej przeglądarce.</li>
              <li>Strona nie wykorzystuje "ciasteczek" do żadnych innych cel&oacute;w. Jeżeli uważasz, iż pomimo to jakieś informacje są zapisywane, to takie operacje być może wykonuje przeglądarka lub jej plugin w spos&oacute;b automatyczny, za co nie odpowiadamy.</li>
            </ul>`}
        />
      </Box>

      <Footer
        id="footer"
        logo={{
          imageUrl: '/images/logo_medium.png',
          href: '/',
        }}
        categories={[
          {
            name: 'Zasady',
            elements: [
              {
                text: 'Polityka prywatności',
                href: '/polityka-prywatnosci',
              },
              {
                text: 'Płatność i dostawa',
                href: '/platnosc-i-dostawa',
              },
              {
                text: 'FAQ',
                href: '/faq',
              },
            ],
          },
          {
            name: 'Pomoc',
            elements: [
              {
                text: 'Jak zamawiać?',
                href: '/jak-zamawiac',
              },
              {
                text: 'Akceptowalne pliki',
                href: '/akceptowalne-pliki',
              },
              {
                text: 'Projektowanie',
                href: '/projektowanie',
              },
            ],
          },
        ]}
      />
    </Flex>
  );
}

export default PolicyPage;
